import { Pipe } from '@angular/core';
import { wrapDeep, isDeepObject } from '../utils/utils';
var DeepPipe = (function () {
    function DeepPipe() {
    }
    DeepPipe.prototype.transform = function (value) {
        if (isDeepObject(value)) {
            return value;
        }
        return wrapDeep(value);
    };
    return DeepPipe;
}());
export { DeepPipe };
DeepPipe.decorators = [
    { type: Pipe, args: [{
                name: 'deep'
            },] },
];
/** @nocollapse */
DeepPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=deep.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/deep.pipe.js
// module id = 229
// module chunks = 103